export interface IEFileDisplayStatus {
    statusses: IEFileStatus[];
    name: string;
    indicator: string;
}

export interface IEFileStatus{
    status: string;
    index:  number;
}